import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spaces-boro-id"
export default class extends Controller {
  static targets = ['region', 'location'];
  
  connect() {
    const regionInputs = this.regionTarget.querySelectorAll("input[type=checkbox]")
    const locationInputs = this.locationTarget.querySelectorAll("input[type=checkbox]")
    const locationCheckboxes = this.locationTarget.querySelectorAll("span.checkbox")

    const regionChecked = [...regionInputs].some(region => region.checked == true);
    
    regionInputs.forEach(region => {
      region.addEventListener('change', () => {
        this.hide(regionInputs, locationInputs, locationCheckboxes);        
        locationInputs.forEach(location => {
          location.checked = false;
        });
      })
    });

    if(regionChecked){
      this.hide(regionInputs, locationInputs, locationCheckboxes);
    }
  }
  
  hide(regionInputs, locationInputs, locationCheckboxes) {
    let showArr = [];
    locationCheckboxes.forEach(span => {
      span.classList.add('hidden');
    });
    regionInputs.forEach(region => {
      if(region.checked){
        locationInputs.forEach(loc => {
          if(region.dataset.boroughId == loc.dataset.boroughId){
            if(!showArr.includes(loc)){
              showArr.push(loc);
            }
          }
        });
      }
    });
    showArr.forEach(entry => {
      locationCheckboxes.forEach(span => {
        if(span.contains(entry)){
          span.classList.remove('hidden');
        }
      });
    });
  }

}
